import React, { useState } from "react"
import TextInput from "../ui/textInput"
import { Dismiss16Filled, Search16Filled } from "@fluentui/react-icons"
import { Box, IconButton, Typography } from "@mui/material"

/**
 * Used as a searchbox that updates the onSearch function every time input is changed
 * 
 * ---
 * 
 * @param {Object} props - The props passed to the component.
 * @param {string} props.searchTerm - The current search term displayed in the input field.
 * @param {function} props.onSearch - A callback function that gets called with the updated search term whenever the user types in the input field.
 * 
 * @returns {JSX.Element} A search input field with a placeholder "Search...".
 */
const SearchBox = ({ label, searchTerm, onSearch, boxSx={} }) => {

    const [isFocused, setIsFocused] = useState(false);
  
  return (
    <Box width='100%' sx={{...boxSx}}>
      {label &&
      <Typography
        variant="body2"
        sx={{
          textAlign: 'left',
          color: isFocused ? 'var(--navyBlue-default)' : 'var(--black)',
          transition: 'color 0.2s ease-in-out',
          fontWeight: '500',
          marginBottom: 0.5,
        }}
      >
        {label}
      </Typography>}

      <TextInput
        placeholder="Search..."
        type="search"
        value={searchTerm}
        onChange={(e) => onSearch(e.target.value)}
        leadingIcon={<Search16Filled />}
        trailingIcon={
          searchTerm && (
            <Dismiss16Filled/>
          )
        }
        onIconClick={() => onSearch("")}
        sx={{
          // width: "200px",
          "& .MuiOutlinedInput-root": {
            height: "45px",
            paddingLeft: "8px",
          },
          "& input[type='search']::-webkit-search-cancel-button": {
              display: "none", // Hides default close button
            },
        }}
      />  
    </Box>
  )
}

export default SearchBox